(() => {
  const root = document.querySelector('.dermafix-shopify-root');
  if (!root) return;

  const parseBoolean = (value) => String(value).toLowerCase() === 'true';
  const domainParamName = root.dataset.domainParam || 'domain';
  const passQuery = parseBoolean(root.dataset.passQuery);

  function normalizeDomain(value) {
    if (!value) return '';
    try {
      const withProtocol = /^https?:\/\//i.test(value) ? value : `https://${value}`;
      return new URL(withProtocol).host;
    } catch (_) {
      return value.replace(/^https?:\/\//i, '').replace(/\/$/, '');
    }
  }

  function resolveBinomUrl(raw) {
    let target = raw || 'https://{domain}/click.php?lp=1';
    const current = new URL(window.location.href);
    let trackerDomain = current.searchParams.get(domainParamName) || sessionStorage.getItem('dermafix_binom_domain') || '';
    trackerDomain = normalizeDomain(trackerDomain);
    if (trackerDomain) {
      sessionStorage.setItem('dermafix_binom_domain', trackerDomain);
      target = target.replaceAll('{domain}', trackerDomain);
    }
    if (!passQuery) return target;
    try {
      const targetUrl = new URL(target);
      current.searchParams.forEach((value, key) => {
        if (key !== domainParamName && !targetUrl.searchParams.has(key)) targetUrl.searchParams.set(key, value);
      });
      return targetUrl.toString();
    } catch (_) {
      return target;
    }
  }

  root.querySelectorAll('[data-binom-link]').forEach((link) => {
    const raw = link.getAttribute('href') || root.dataset.binomBase;
    link.setAttribute('href', resolveBinomUrl(raw));
  });

  const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
  const mains = [...root.querySelectorAll('[data-gallery-main]')];
  function showGallery(index) {
    mains.forEach((image, i) => { image.style.display = i === index ? '' : 'none'; });
    thumbs.forEach((button, i) => {
      button.classList.toggle('ring-[3px]', i === index);
      button.classList.toggle('ring-primary-green', i === index);
      button.classList.toggle('ring-offset-0', i === index);
      button.classList.toggle('bg-gray-200', i !== index);
      button.classList.toggle('hover:ring-2', i !== index);
      button.classList.toggle('hover:ring-gray-300', i !== index);
      button.setAttribute('aria-pressed', i === index ? 'true' : 'false');
    });
  }
  thumbs.forEach((button) => button.addEventListener('click', () => showGallery(Number(button.dataset.galleryThumb || 0))));

  const offerCards = [...root.querySelectorAll('[data-offer-card]')];
  function selectOffer(index) {
    offerCards.forEach((card, i) => {
      const selected = i === index;
      card.classList.toggle('df-offer-selected', selected);
      card.classList.toggle('df-offer-unselected', !selected);
      card.setAttribute('aria-checked', selected ? 'true' : 'false');
      const shell = card.querySelector('[data-radio-shell]');
      if (shell) {
        shell.classList.toggle('border-primary-green', selected);
        shell.classList.toggle('border-slate-900/20', !selected);
      }
      const dot = card.querySelector('[data-radio-dot]');
      if (dot) dot.style.display = selected ? '' : 'none';
      if (selected) {
        card.classList.add('border-primary-green', 'bg-[#61F8A629]');
        card.classList.remove('border-slate-900/20', 'bg-white');
      } else {
        card.classList.remove('border-primary-green', 'bg-[#61F8A629]');
        card.classList.add('border-slate-900/20', 'bg-white');
      }
    });
  }
  offerCards.forEach((card) => {
    const choose = () => selectOffer(Number(card.dataset.offerCard || 0));
    card.addEventListener('click', choose);
    card.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); choose(); }
    });
  });

  // The captured page shows a 00:00 urgency timer. Keep it visually active without changing page dimensions.
  root.querySelectorAll('time.tabular-nums').forEach((timer) => {
    let seconds = 15 * 60;
    const tick = () => {
      const m = String(Math.floor(seconds / 60)).padStart(2, '0');
      const s = String(seconds % 60).padStart(2, '0');
      timer.textContent = `${m}:${s}`;
      seconds = seconds > 0 ? seconds - 1 : 15 * 60;
    };
    tick();
    setInterval(tick, 1000);
  });
})();
